// src/pages/PurchaseReturnLedger/PurchaseReturnLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPurchaseReturnLedgerApi } from "../../apiservice/reports";
import { getAccountByTypeApi } from "../../apiservice/setting";

export const fetchPurchaseReturnLedger = createAsyncThunk(
  "purchaseReturnLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getPurchaseReturnLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchPurchaseReturnAccounts = createAsyncThunk(
  "purchaseReturnLedger/fetchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "purchase_return" });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
